import { call, put, takeLatest, select } from 'redux-saga/effects';
import * as Actions from './change-requests-actions';
import * as Apis from '../../apis';
import { getCodesFromDetailState } from '@/app/common/conversation/sagas';

export function* getChangeRequestsList(request) {
  try {
    const changeRequests = yield call(Apis.getOrderVerificationDetailsChangeRequests, request.payload);
    yield put(Actions.getChangeRequestsListSuccess(changeRequests));
  } catch (error) {
    yield put(Actions.getChangeRequestsListFailure(error));
  }
}

export function* buyerApproveChangeRequest(request) {
  try {
    const codes = yield select(getCodesFromDetailState);
    yield call(Apis.putBuyerApproveChangeRequest, { ...request.payload, customerCode: codes.customerCode });
    yield put(Actions.buyerConfirmSuccess(request.payload));
  } catch (error) {
    yield put(Actions.buyerConfirmFailure(error));
  }
}

export function* supplierApproveChangeRequest(request) {
  try {
    yield call(Apis.putSupplierApproveChangeRequest, request.payload);
    yield put(Actions.supplierConfirmChangeRequestSuccess(request.payload));
  } catch (error) {
    yield put(Actions.supplierConfirmChangeRequestFailure());
  }
}

export function* watchGetPoItemChangeRequestsSaga() {
  yield takeLatest(Actions.CHANGE_REQUESTS_LIST_ACTIONS.REQUEST, getChangeRequestsList);
}

export function* watchBuyerApproveChangeRequest() {
  yield takeLatest(Actions.BUYER_CONFIRM_CHANGE_REQUEST.REQUEST, buyerApproveChangeRequest);
}

export function* watchSupplierApproveChangeRequest() {
  yield takeLatest(Actions.SUPPLIER_CONFIRM_CHANGE_REQUEST.REQUEST, supplierApproveChangeRequest);
}
